module.exports = __webpack_public_path__ + "static/media/CT_CC (Legacy Trail).c983ad04.png";